<div class="message-prompt" [ngClass]="data.type">
  @if (data.type==='success') {
  <div class="align success-bg">
    <mat-icon class="succes">done</mat-icon>
  </div>
  } @if (data.type==='warning') {
  <div class="align warn-bg">
    <img src="assets/images/warning.svg" class="warn-yellow" />
  </div>
  } @if (data.type==='error') {
  <div class="align error-bg">
    <img src="assets/images/warning.svg" class="error-red" />
  </div>
  }
  <div class="message">
    <span>{{ data.text }}</span>
  </div>
  @if (data.type==='error') {
  <span class="close-btn">
    <button mat-icon-button (click)="onClose()" class="gap-left-xs">
      <span class="sif sif-12 sif-delete sif-gray"></span>
    </button>
  </span>
  }
</div>
